import { CHEKCOUT, CART } from '../actions';

const initialState = {
    checkOutData: null,
    dialogAccountNotLinked: false,
    dialogBalance: false,
    dialogValidatePin: false,
    dialogPhoneNumber: false,
    dialogFurtherInformation: false,
    validatePinError: null,

    dialogPolicy: false,
    doAfterAcceptPolicy: '',

    orderingFetching: false,
    orderingData: null,
    orderingError: false,
    orderingDataError: null,

    sfPlusPaymentDialogSuccess: false,
    sfPlusPaymentData: null,
    sfPlusPaymentDialogFailed: false,
    sfPlusPaymentError: false,
    sfPlusPaymentDataError: null,
    kBankData: {
        INVMERCHANT: 0,
        DETAIL2: 'SF SHOP',
        AMOUNT2: '100'
    },

    dialogThaiQR: false,
    thaiQRorderingFetching: false,
    thaiQRorderingData: null,
    thaiQRorderingError: false,
    thaiQRorderingDataError: null
};

export default (state = initialState, { type, payload, error }) => {
    switch (type) {
        case CART.GET_CART_DATA:
            return {
                ...state,
                checkOutData: null,
            };

        case CART.CHECK_OUT_DATA:
            return {
                ...state,
                checkOutData: payload.checkOutData,
            };
        case CART.CLEAR_BUY_NOW:
            return {
                ...state,
                checkOutData: null,
            }

        case CHEKCOUT.OPEN_DIALOG_CHECKOUT_POLICY:
            return { ...state, dialogPolicy: true, doAfterAcceptPolicy: payload };

        case CHEKCOUT.CLOSE_DIALOG_CHECKOUT_POLICY:
            return { ...state, dialogPolicy: false, doAfterAcceptPolicy: '' };

        case CHEKCOUT.OPEN_DIALOG_SF_PLUS_ACCOUNT_NOT_LINKED:
            return { ...state, dialogAccountNotLinked: true };

        case CHEKCOUT.CLOSE_DIALOG_SF_PLUS_ACCOUNT_NOT_LINKED:
            return { ...state, dialogAccountNotLinked: false };

        case CHEKCOUT.OPEN_DIALOG_SF_PLUS_BALANCE:
            return { ...state, dialogBalance: true };

        case CHEKCOUT.CLOSE_DIALOG_SF_PLUS_BALANCE:
            return { ...state, dialogBalance: false };

        case CHEKCOUT.OPEN_DIALOG_PHONE_NUMBER:
            return { ...state, dialogPhoneNumber: true };

        case CHEKCOUT.CLOSE_DIALOG_PHONE_NUMBER:
            return { ...state, dialogPhoneNumber: false };

        case CHEKCOUT.OPEN_DIALOG_FURTHER_INFORMATION:
            return { ...state, dialogFurtherInformation: true };

        case CHEKCOUT.CLOSE_DIALOG_FURTHER_INFORMATION:
            return { ...state, dialogFurtherInformation: false };

        case CHEKCOUT.OPEN_DIALOG_SF_PLUS_VALIDATE_PIN:
            return { ...state, dialogValidatePin: true, validatePinError: null };

        case CHEKCOUT.CLOSE_DIALOG_SF_PLUS_VALIDATE_PIN:
            return { ...state, dialogValidatePin: false };

        case CHEKCOUT.SF_PLUS_VALIDATE_PIN_SUCCESS:
            return { ...state, dialogValidatePin: false, validatePinError: null };

        case CHEKCOUT.SF_PLUS_VALIDATE_PIN_FAILED:
            return { ...state, validatePinError: error };

        case CHEKCOUT.SF_PLUS_ORDERING_FETCHING:

        case CHEKCOUT.CREDIT_CARD_ORDERING_FETCHING:
            return {
                ...state,
                orderingFetching: true,
                orderingData: null,
                orderingError: false,
                orderingDataError: null,

                sfPlusPaymentDialogSuccess: false,
                sfPlusPaymentDialogFailed: false,
                sfPlusPaymentError: false,
                sfPlusPaymentDataError: null
            };

        case CHEKCOUT.CREDIT_CARD_ORDERING_SUCCESS:
            return {
                ...state,
                orderingData: payload,
                kBankData: {
                    ...state.kBankData,
                    INVMERCHANT: payload.vistatransno,
                    AMOUNT2: payload.amount //"100"
                }
            };

        case CHEKCOUT.SF_PLUS_ORDERING_FAILED:
        case CHEKCOUT.CREDIT_CARD_ORDERING_FAILED:
            return {
                ...state,
                orderingFetching: false,
                orderingData: { status: false },
                orderingError: true,
                orderingDataError: error
            };

        case CHEKCOUT.CLOSE_DIALOG_SF_PLUS_ORDERING_FAILED:
            return {
                ...state,
                orderingError: false,
                orderingDataError: null
            };

        case CHEKCOUT.SF_PLUS_PAYMENT_SUCCESS:
            return {
                ...state,
                orderingFetching: false,
                sfPlusPaymentDialogSuccess: true,
                sfPlusPaymentData: payload
            };

        case CHEKCOUT.SF_PLUS_PAYMENT_FAILED:
            return {
                ...state,
                orderingFetching: false,
                sfPlusPaymentDialogFailed: true,
                sfPlusPaymentError: true,
                sfPlusPaymentDataError: error
            };

        case CHEKCOUT.CLOSE_DIALOG_SF_PLUS_PAYMENT_SUCCESS:
            return {
                ...state,
                sfPlusPaymentData: null,
                sfPlusPaymentDialogSuccess: false
            };

        case CHEKCOUT.CLOSE_DIALOG_SF_PLUS_PAYMENT_FAILED:
            return {
                ...state,
                sfPlusPaymentDialogFailed: false,
                sfPlusPaymentError: false,
                sfPlusPaymentDataError: null
            };

        case CHEKCOUT.THAIQR_ORDERING_FETCHING:
            return {
                ...state,
                orderingFetching: true,
                orderingData: null,
                orderingError: false,
                orderingDataError: null,

                sfPlusPaymentDialogSuccess: false,
                sfPlusPaymentDialogFailed: false,
                sfPlusPaymentError: false,
                sfPlusPaymentDataError: null,
                sfPlusPaymentData: null,

                thaiQRorderingData: null
            };

        case CHEKCOUT.THAIQR_ORDERING_SUCCESS:
            return {
                ...state,
                orderingFetching: false,
                thaiQRorderingData: payload
            };

        case CHEKCOUT.THAIQR_ORDERING_FAILED:
            return {
                ...state,
                orderingFetching: false,
                thaiQRorderingData: null,
                orderingError: true,
                orderingDataError: error
            };

        case CHEKCOUT.KPAYMENT_CHARGE_FETCHING:
            return {
                ...state,
                orderingFetching: true,
                // orderingData: null,
                // orderingError: false,
                // orderingDataError: null,

                // sfPlusPaymentDialogSuccess: false,
                // sfPlusPaymentDialogFailed: false,
                // sfPlusPaymentError: false,
                // sfPlusPaymentDataError: null,
                // sfPlusPaymentData: null,

                // thaiQRorderingData: null
            };

        case CHEKCOUT.KPAYMENT_CHARGE_SUCCESS:
            return {
                ...state,
                orderingFetching: false,
                // thaiQRorderingData: payload
            };

        case CHEKCOUT.KPAYMENT_CHARGE_FAILED:
            return {
                ...state,
                orderingFetching: false,
                // thaiQRorderingData: null,
                // orderingError: true,
                // orderingDataError: error
            };

        case CHEKCOUT.OPEN_DIALOG_THAIQR:
            return { ...state, dialogThaiQR: true };

        case CHEKCOUT.CLOSE_DIALOG_THAIQR:
            return {
                ...state,
                dialogThaiQR: false,
                orderingFetching: false,
                thaiQRorderingData: null,
                orderingError: false,
                orderingDataError: null
            };

        default:
            return state;
    }
};
